/**
 * Fluid cursor effect — configuration constants
 * Inspired by PavelDoGreat/WebGL-Fluid-Simulation and faraasat/smokey-fluid-cursor
 * (minimal extracted implementation)
 *
 * Tweak these values to adjust the look and performance of the effect.
 */

const FLUID_CONFIG = {
  // --- Simulation grid ---
  SIM_RESOLUTION: 64,         // Physics grid (lower = cheaper, 64–128 typical)
  DYE_RESOLUTION: 512,        // Visual grid (higher = sharper smoke, 512–1024)

  // --- Dissipation (how fast things fade) ---
  DENSITY_DISSIPATION: 3.0,   // Dye fade speed (higher = faster fade, smokier)
  VELOCITY_DISSIPATION: 1.8,  // Velocity fade speed (higher = less travel)

  // --- Pressure ---
  PRESSURE: 0.15,             // Pressure decay per frame (low = less persistent flow)
  PRESSURE_ITERATIONS: 12,    // Jacobi iterations (lower = cheaper, 12–20)

  // --- Vorticity ---
  CURL: 8,                    // Vorticity confinement strength (lower = less swirl)

  // --- Splat (mouse injection) ---
  SPLAT_RADIUS: 0.3,          // Gaussian radius (/ 100 in shader)
  SPLAT_FORCE: 3000,          // Mouse velocity multiplier (lower = subtler)

  // --- Color (BY ZY violet, low alpha) ---
  // These are premultiplied — keep values low for subtlety
  COLOR: { r: 0.08, g: 0.03, b: 0.14 },   // Deep violet tint

  // --- Display ---
  SHADING: true,              // Pseudo-3D lighting on smoke

  // --- Performance ---
  MAX_DPR: 1.25,              // Max device pixel ratio for canvas
};

export default FLUID_CONFIG;
